module.exports = __webpack_public_path__ + "assets/images/6f050f4fabb4d9b677da91b29ec994e5.png";